// extracted by mini-css-extract-plugin
export default {"rating":"EB-z","numberOfStars":"FB-z","count":"GB-z","barGraphSpacing":"HB-z","barGraph":"IB-z"};